<template>
   
      <div class="mod-sys__slcustomer">
       
        <el-table v-loading="dataListLoading" :data="userInfo" border  style="width: 100%;">
          <!-- <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column> -->
          <el-table-column prop="cumulativeEntry" label="累计进件" header-align="center" align="center"></el-table-column>
          <el-table-column prop="incomingToday" label="今日进件" header-align="center" align="center"></el-table-column>
          <el-table-column prop="cumulativeLoan" label="累计放款" header-align="center" align="center"></el-table-column>
          <el-table-column prop="loanToday" label="今日放款" header-align="center" align="center"></el-table-column>
          <el-table-column prop="cumulativeCommission" label="累计提成" header-align="center" align="center"></el-table-column>
          <el-table-column prop="commissionToday" label="今日提成" header-align="center" align="center"></el-table-column>
          <el-table-column prop="cumulativeWithdrawal" label="累计提现" header-align="center" align="center"></el-table-column>
          <el-table-column prop="withdrawToday" label="今日提现" header-align="center" align="center"></el-table-column>
         
        </el-table>
        <!-- <el-pagination
          :current-page="page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="limit"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="pageSizeChangeHandle"
          @current-change="pageCurrentChangeHandle">
        </el-pagination> -->
        <!-- 弹窗, 新增 / 修改 -->
        <!-- <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update> -->
      </div>
    
  </template>
  
  <script>
  import mixinViewModule from '@/mixins/view-module'
  // import AddOrUpdate from './entry-add-or-update'
  export default {
    // mixins: [mixinViewModule],
   
    mounted(){
    
    },
    data () {
      return {
        // mixinViewModuleOptions: {
        //   getDataListURL: '/sys/sluser/page',
        //   getDataListIsPage: true,
        //   exportURL: '/sys/slcustomer/export',
        //   deleteURL: '/sys/slcustomer',
        //   deleteIsBatch: true
        // },
        userInfo: [],
        text:'修改',
        userTypes: [],
        statusList: [],
        dataForm: {
          status: '',
          id: '',
          userType: '',
         
        }
      }
    },
 
    methods: {
      //修改状态
      submitStatus(row){
        console.log(this.dataList.findIndex(item => item.id == row.id))
        let n = this.dataList.findIndex(item => item.id == row.id)
        this.$set(this.dataList,n,{...this.dataList[n],myishsow: !this.dataList[n].myishsow})
        if(row.myishsow){
          console.log(this.dataList)
        }
      },

      init(v){
       console.log(v)
       console.log('12312312')
       this.userInfo.push(v)
      },

      geteducation(v,name){
        if(name == 'userType')  return this.userTypes.filter(item => item.value == v)[0]?.label ;
        if(name == 'education') return this.educations.filter(item => item.value == v)[0]?.label ;
        if(name == 'vipLevelId') return this.vipLevels.filter(item => item.value == v)[0]?.label ;
        if(name == 'maritalStatus') return this.maritalStatus.filter(item => item.value == v)[0]?.label ;
        if(name == 'isAuth') return this.isAuth.filter(item => item.value == v)[0]?.label ;
      },
      
    },
    components: {
      // AddOrUpdate
    }
  }
  </script>
  